export const outlet = {
  view_menu: 'View',
  order: 'Order',
  pre_order: 'Preorder',
  open: 'Open',
  closed: 'Closed',
}
